import React from 'react';
import PropTypes from 'prop-types';

const ContentSwitch = ({ index = 0, children, ...rest }) =>
  !(index < 0) && React.cloneElement(React.Children.toArray(children)[index], { ...rest });

ContentSwitch.propTypes = {
  index: PropTypes.number,
  children: PropTypes.arrayOf(PropTypes.node),
};

export default ContentSwitch;



// WEBPACK FOOTER //
// ./src/components/ContentSwitch/ContentSwitch.jsx